import { useEffect, useRef, useState } from 'react'
import useAuth from '../../hooks/useAuth'
import { useNavigate } from 'react-router-dom'

import styles from './login.module.css'

import { toast, ToastContainer } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
import { authApi } from '../../services/api/api';
import { Eye, EyeClosed } from 'lucide-react';

export default function Login() {

    const navigate = useNavigate()

    const api = authApi()

    const [email, setEmail] = useState('')
    const [password, setPassword] = useState('')
    const [viewPassword, setViewPassword] = useState(false)
    const ref = useRef(null)

    const auth = useAuth()


    useEffect(() => {

        // Se o AuthProvider ainda está checando o token, não faz nada

        if (auth.loading) return;

        // Se terminou de carregar e já existe usuário, vai direto pro destino
        if (auth.user) {
            const destination = (auth.lastRoute === '/' || auth.lastRoute === '')
                ? '/dashboard'
                : auth.lastRoute;
            navigate(destination);
        }
    }, [auth.user, auth.loading]); // <--- Importante monitorar os dois

    const handleLogin = async () => {

        if (email === '') {
            toast.info('Preencha o e-mail.', {
                theme: 'dark',
                toastId: 'email'
            })
            return
        }
        if (password === '') {
            toast.info('Preencha a senha.', {
                theme: 'dark',
                toastId: 'password'
            })
            return
        }

        toast.info('Carregando...', {
            theme: 'dark',
            toastId: 'load'
        })

        const data = await auth.signin(email, password)

        if (data) {
            console.log(auth.lastRoute)
            if (auth.lastRoute == '/' || auth.lastRoute == '') {
                return navigate('/dashboard')
            }
            return navigate(auth.lastRoute)
        } else {
            toast.error('Usuário ou senha incorretos', {
                theme: 'dark',
                toastId: 'errorLogin'
            })
        }


    }

    async function handleUpdatePass() {

        if (email == '') {
            toast.error('Preencha o E-mail', { theme: 'dark', toastId: 'errorEmail' })
            return
        }

        toast.loading('Carregando...', { theme: 'dark', toastId: 'attPass' })

        const data = await api.resetPassword(email)

        if (data == 'passwords.sent') {
            toast.dismiss('attPass')
            toast.info('Acesse seu e-mail para trocar a senha', { theme: 'dark', toastId: 'att' })
        } else if (data == 'passwords.throttled') {
            toast.dismiss('attPass')
            toast.info('Acesse seu e-mail para trocar a senha', { theme: 'dark', toastId: 'att' })
        } else {
            toast.dismiss('attPass')
            toast.error('E-mail inválido', { theme: 'dark', toastId: 'att' })
        }

    }

    useEffect(() => {
        const listener = (e: KeyboardEvent) => {
            if (e.key === 'Enter') {
                if (email !== '' && password !== '') {
                    ref.current?.click();
                }
            }
        };
        window.addEventListener('keyup', listener);
        return () => window.removeEventListener('keyup', listener);
    }, [email, password]);


    function handleViewPassword() {
        setViewPassword(true)
        if (viewPassword) {
            setViewPassword(false)
        }
    }

    if (auth.loading) {
        // Retorna apenas o fundo azul do seu sistema para não dar o flash branco
        return <div style={{ backgroundColor: '#181846' }} className="w-screen h-screen"></div>;
    }

    return (
        <div style={{ backgroundColor: '#181846' }} className="flex items-center justify-center overflow-hidden w-screen h-screen relative font-['Montserrat']">
            {/* Vídeo de Background */}
            <video
                style={{ minWidth: '1500px' }}
                className="w-screen h-screen object-cover absolute z-0 pointer-events-none xs:!min-w-full"
                loop autoPlay muted playsInline
            >
                <source src={`../../assets/videos/Biblioteca_baixa.mp4`} type="video/mp4" />
            </video>

            {/* Overlay para contraste */}
            <div className="absolute inset-0 bg-black/40 z-10"></div>

            {/* Conteúdo Principal - Glass Card */}
            <div className="relative z-20 flex flex-col justify-center items-center w-full max-w-[350px] bg-[#002462]/80 backdrop-blur-md py-12 px-10 rounded-[24px] border border-white/10 shadow-2xl mx-8 md:mx-0 ">
                {/* Logo e Título */}
                {/* <div className="flex gap-4 justify-center items-center mb-12">
                    <div className="border-r border-white pr-4">
                        <img className="w-10" src="../../assets/images/logoMiniBranco.png" alt="logo minificada" />
                    </div>
                    <h1 style={{ fontFamily: 'Gruppo' }} className="text-4xl text-white font-semibold">
                        Biblioteca
                    </h1>
                </div> */}

                <div className="flex gap-4 justify-center items-center mb-12">
                    <div className="">
                        <img className="w-48" src="../../assets/images/logoBiblioteca.svg" alt="logo minificada" />
                    </div>
                    {/* <h1 style={{ fontFamily: 'Gruppo' }} className="text-4xl text-white font-semibold">
                        Biblioteca
                    </h1> */}
                </div>

                {/* Formulário */}
                <div style={{ fontFamily: 'Montserrat' }} className="flex flex-col w-full  rounded-2xl ">
                    <label htmlFor="email" className='text-white text-xs font-bold pb-1.5 tracking-[0.2em]'>E-mail</label>
                    <input
                        type="text"
                        placeholder="E-mail"
                        autoComplete="username"
                        className="placeholder:text-xs p-2.5 rounded-lg outline-none focus:ring-2 focus:ring-cyan-500 text-sm"
                        onChange={(e) => setEmail(e.target.value)}
                        value={email}
                    />

                    <div className="relative mt-5">
                        <label htmlFor="password" className='text-white text-xs font-bold pb-1.5 tracking-[0.2em]'>Senha</label>
                        <input
                            type={viewPassword ? 'text' : 'password'}
                            autoComplete="current-password"
                            placeholder="Senha"
                            className="placeholder:text-xs p-2.5 rounded-lg w-full outline-none focus:ring-2 focus:ring-cyan-500 text-sm"
                            onChange={(e) => setPassword(e.target.value)}
                            value={password}
                        />

                        {/* Ícones centralizados dinamicamente */}
                        <div
                            className="absolute right-3 top-11 -translate-y-1/2 cursor-pointer text-gray-500 hover:text-cyan-600 transition-colors"
                            onClick={handleViewPassword}
                        >
                            {viewPassword ? (
                                <Eye size={17} />
                            ) : (
                                <EyeClosed size={17} />
                            )}
                        </div>
                    </div>

                    <button
                        ref={ref}
                        className="mt-6 p-3 bg-[#103E89] uppercase text-xs rounded-lg text-white font-bold hover:bg-[#103E89]/70 transition-all transform active:scale-95"
                        onClick={handleLogin}
                    >
                        Entrar
                    </button>

                    <span className="text-center text-xs mt-8 text-white font-light">

                        <button className=" pl-2 hover:underline " onClick={handleUpdatePass}>
                            Esqueceu sua senha?
                        </button>
                    </span>
                </div>
            </div>

            <ToastContainer />

            {/* Link Externo */}
            <a
                href="https://acreditarfidc.com.br/"
                target="_blank"
                rel="noreferrer"
                className="text-center text-white font-light text-sm absolute bottom-6 z-20 hover:underline transition-all"
            >
                Acesse o site do Acreditar Fidc
            </a>
        </div>
    )
} 